import { createStore } from '@helpers/utils';

export const initialStateGlobalFilter = {
    enabled: false,
    groupType: {
        id: 1,
        name: 'sap',
    },
    custGroup: '',
    customer: '',
    sellout_date: null,
    sellout_value: { id: 'sellout_value_paragon', name: 'HET Paragon' },
};

export const useGlobalFilter = createStore(initialStateGlobalFilter);
